import { DateTimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { FC, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { IStyledAttributes, useTimezone } from "@ryde/shared";

import { LocalizationProvider } from "../localization";

interface IDateFilter {
  onFromChange?: (date: TDateISO) => void;
  onToChange?: (date: TDateISO) => void;
}

export const DateFilter: FC<IDateFilter> = ({ onFromChange, onToChange }) => {
  const { t } = useTranslation();
  const { timezone } = useTimezone();
  const [fromDate, setFromDate] = useState<TDateISO | null>(null);
  const [toDate, setToDate] = useState<TDateISO | null>(null);

  const handleChangeFromDate = useCallback(
    (e: dayjs.Dayjs | null): void => {
      if (e) {
        setFromDate(e.toISOString());
        onFromChange?.(e.toISOString());
      }
    },
    [setFromDate, onFromChange],
  );

  const handleChangeToDate = useCallback(
    (e: dayjs.Dayjs | null): void => {
      if (e) {
        setToDate(e.toISOString());
        onToChange?.(e.toISOString());
      }
    },
    [setToDate, onToChange],
  );

  return (
    <div>
      <LocalizationProvider>
        <PickerContainer>
          <DateTimePicker
            ampm={false}
            timezone={timezone}
            format="DD.MM.YYYY HH:mm"
            value={fromDate ? dayjs.utc(fromDate) : null}
            onChange={(e: dayjs.Dayjs | null) => handleChangeFromDate(e)}
            label={t("general.FROM")}
          />
          <DateTimePicker
            ampm={false}
            format="DD.MM.YYYY HH:mm"
            timezone={timezone}
            value={toDate ? dayjs.utc(toDate) : null}
            onChange={(e: dayjs.Dayjs | null) => handleChangeToDate(e)}
            label={t("general.TO")}
          />
        </PickerContainer>
      </LocalizationProvider>
    </div>
  );
};

const PickerContainer = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "date-picker-filter-container",
})`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2rem;
  margin-bottom: 1rem;
`;
